/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase (a-z)`)
};

const es_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúsculas (a-z)`)
};

const de_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleinbuchstaben (a-z)`)
};

const nl_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine letters (a-z)`)
};

const fr_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuscules (a-z)`)
};

const it_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuscole (a-z)`)
};

const pt_br2_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúsculas (a-z)`)
};

const pt_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúsculas (a-z)`)
};

const ja_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小文字 (a-z)`)
};

const zh_pw_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小写字母 (a-z)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_lowercase = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_lowercase(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_lowercase", locale)
	if (locale === "en") return en_pw_lowercase(inputs)
	if (locale === "es") return es_pw_lowercase(inputs)
	if (locale === "de") return de_pw_lowercase(inputs)
	if (locale === "nl") return nl_pw_lowercase(inputs)
	if (locale === "fr") return fr_pw_lowercase(inputs)
	if (locale === "it") return it_pw_lowercase(inputs)
	if (locale === "pt-BR") return pt_br2_pw_lowercase(inputs)
	if (locale === "pt") return pt_pw_lowercase(inputs)
	if (locale === "ja") return ja_pw_lowercase(inputs)
	return zh_pw_lowercase(inputs)
};